
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Force clean cache for published site
if (window.location.hostname.includes('lovable.app')) {
  // Clear any session storage that might interfere with rendering
  try {
    sessionStorage.clear();
    console.log('Session storage cleared for deployment');
  } catch (e) {
    console.warn('Could not clear session storage:', e);
  }
}

// Add error boundary at the application root level
const renderApp = () => {
  try {
    const rootElement = document.getElementById("root");
    
    if (!rootElement) {
      console.error("Root element not found!");
      return;
    }
    
    createRoot(rootElement).render(<App />);
    
    console.log("Application successfully rendered");
    console.log("Deployment environment:", {
      hostname: window.location.hostname,
      protocol: window.location.protocol,
      userAgent: navigator.userAgent,
      isPublished: window.location.hostname.includes('lovable.app')
    });
  } catch (error) {
    console.error("Failed to render application:", error);
    
    // Display a fallback UI if the app fails to render
    const rootElement = document.getElementById("root");
    if (rootElement) {
      rootElement.innerHTML = `
        <div style="padding: 20px; text-align: center; font-family: sans-serif;">
          <h2>Something went wrong</h2>
          <p>The application couldn't load properly. Please try refreshing the page.</p>
          <button onclick="window.location.reload()" style="padding: 8px 16px; margin-top: 20px; cursor: pointer;">
            Refresh Page
          </button>
        </div>
      `;
    }
  }
};

renderApp();

// Add connection resilience
window.addEventListener('online', () => {
  console.log('Connection restored, reloading application');
  window.location.reload();
});
